import { inject, injectable } from 'inversify';

import { DtoBase, UserModels } from '@project44-models/iam-gateway';

import { UserTenantSpecificUnifiedRolesQueryUserCase } from '../../domain/abstract';
import { DeactivatedUserTenantSpecificRolesException } from '../../domain/errors/DeactivatedUserTenantSpecificRolesException';
import { UserServiceClientAdapter } from '../../infrastructure/adapters/UserServiceClient.adapter';

@injectable()
export class UserTenantSpecificUnifiedRolesQuery extends UserTenantSpecificUnifiedRolesQueryUserCase {
  constructor(
    @inject(UserServiceClientAdapter)
    private readonly unifiedRolesClientAdapter: UserServiceClientAdapter,
  ) {
    super();
  }

  public readonly execute: UserTenantSpecificUnifiedRolesQueryUserCase['execute'] =
    async (userPrincipal, payload) => {
      this.validateUseCase(userPrincipal);

      this.shouldFetchTenantSpecificUserRoles(payload.user);

      const { result } =
        await this.unifiedRolesClientAdapter.getUserTenantSpecificUnifiedRoles(
          payload,
        );

      return {
        userTenantSpecificUnifiedRoles: result,
      };
    };

  public readonly shouldFetchTenantSpecificUserRoles = (
    user: DtoBase<UserModels.UserViewModel>,
  ): void | never => {
    const { deactivatedDateTime } = user.toSerializedModel();

    if (deactivatedDateTime !== null) {
      DeactivatedUserTenantSpecificRolesException.throw(
        user.toSerializedModel(),
      );
    }
  };
}
